import React, { useState } from 'react';
import {
    PlusOutlined
} from '@ant-design/icons';
import {
    Button,
    Form,
    Modal,
    Select,
    Row,
    Col,
    InputNumber,
    message,
    Statistic,
    Typography
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

function AddProduct({ products, formOrder, cartItems }) {

    const [minPrice, setMinPrice] = useState(0);
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/cartItem/createOrderCartItems', data)
                .then(res => {
                    const { total_price } = res.data

                    const grand_total = cartItems.reduce((prev, cur) => prev + cur.total_price, 0) + total_price;
                    let total = grand_total;
                    let vat = 0;

                    if (formOrder.getFieldValue("vatFlag") === 'ราคารวมภาษี') {
                        total = grand_total / 1.07;
                        vat = grand_total - total;
                    }
                    formOrder.setFieldsValue({
                        ...formOrder.getFieldsValue(true),
                        total,
                        vat,
                        grand_total
                    });

                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => form.resetFields()
                    });
                    queryClient.invalidateQueries(['/api/cartItem/getOrderCartItems'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });

    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate(({
                ...values,
                transaction_type: 'OUT',
                total_price: (values.price * values.quantity) - values.discount,
                selling_price: values.price - (values.discount / values.quantity)
            })))
            .catch(err => {
                console.log(err)
                messageApi.open({
                    type: 'error',
                    content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                });
            })
    };

    const onCancelCreate = () => {
        setOpen(false);
    }

    const onSelectProduct = (value, option) => {
        // console.log('value; ', value);
        // console.log('option; ', option);
        const selectProduct = products.find(f => f._id === value);
        // console.log(selectProduct);
        setMinPrice(selectProduct.min_price);
        form.setFieldsValue({
            price: selectProduct.selling_price,
            selling_price: selectProduct.selling_price - form.getFieldValue('discount'),
        });
    }

    // console.log(products);
    // console.log(cartItems);
    return (
        <div>
            {contextHolder}
            <Row justify="end">
                <Col>
                    <Button
                        type='primary'
                        icon={<PlusOutlined />}
                        onClick={() => setOpen(true)}
                    >เพิ่มสินค้า</Button>
                </Col>
            </Row>
            <Modal
                open={open}
                title="เลือกสินค้า"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        ยกเลิก
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        ตกลง
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name='addProduct'
                    initialValues={{
                        price: 0,
                        quantity: 1,
                        discount: 0
                    }}
                >
                    <Form.Item
                        name="product"
                        label="รุ่น"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล',
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            optionFilterProp="children"
                            onSelect={onSelectProduct}
                        >
                            {products.map((product) => (
                                <Select.Option key={product._id} value={product._id} >
                                    {`${product.name}:${product.brand?.name} ${product.description}`}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Row gutter={[8, 8]}>
                        <Col xs={8}>
                            <Form.Item
                                label="ราคา"
                                name="price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={minPrice} style={{ width: "100%", background: '#FFF', color: "#000" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={8}>
                            <Form.Item
                                label="จำนวน"
                                name="quantity"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={1} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={8}>
                            <Form.Item
                                label="ส่วนลด"
                                name="discount"
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row justify="end">
                        {/* <Col >
                            <Typography>ราคาสุทธิ:</Typography>
                        </Col> */}
                        <Col >
                            <Form.Item shouldUpdate>
                                {() => {

                                    return <Statistic
                                        title={<Typography.Title level={4}>รวม :</Typography.Title>}
                                        value={(form.getFieldValue('price') * form.getFieldValue('quantity')) - form.getFieldValue('discount')}
                                        precision={2}
                                        valueStyle={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'end' }}
                                    />
                                }}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div>
    )
}

export default AddProduct